import { useCallback, useEffect, useRef } from 'react';
import { isLiveMap, withLiveMap } from './withLiveMap';

export function useSyncedMaps(mapARef, mapBRef, enabled) {
  const isSyncing = useRef(false);

  const syncMaps = useCallback((sourceMap, targetMap) => {
    if (!sourceMap || !targetMap) return undefined;
    const onMove = () => {
      if (isSyncing.current) return;
      if (!isLiveMap(sourceMap) || !isLiveMap(targetMap)) return;
      isSyncing.current = true;
      try {
        targetMap.setView(sourceMap.getCenter(), sourceMap.getZoom(), { animate: false });
      } catch (_) { /* ignore */ }
      isSyncing.current = false;
    };
    sourceMap.on('move', onMove);
    return () => {
      try { sourceMap.off('move', onMove); } catch (_) { /* ignore */ }
    };
  }, []);

  useEffect(() => {
    if (!enabled || !mapARef.current || !mapBRef.current) return undefined;
    withLiveMap(mapBRef.current, (map) => {
      map.setView(mapARef.current.getCenter(), mapARef.current.getZoom(), { animate: false });
    });
    const cleanA = syncMaps(mapARef.current, mapBRef.current);
    const cleanB = syncMaps(mapBRef.current, mapARef.current);
    return () => {
      cleanA?.();
      cleanB?.();
    };
  }, [enabled, mapARef, mapBRef, syncMaps]);
}
